import React from 'react';
import MentorManagementComponent from '../../../components/admin/coffee-chat/MentorManagementComponent';

const MentorManagement: React.FC = () => {
  return <MentorManagementComponent />;
};

export default MentorManagement;
